module.exports = __webpack_public_path__ + "static/img/xiaomaolvhello.0c6ccbf.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/xiaomaolvhello.png
// module id = mlWN
// module chunks = 173